import { css } from '@emotion/react';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { styled } from '../../../styled';
import { Theme } from '../../../theme/interface/detailed';
import { msgs } from './msgs';
import { useLoadingDots } from './useLoadingDots';

type Interface = {
	className: string;
};

// решил пока не добавлять кастомизацию, т.к. компонент чисто для ошибок
const styles = css`
	padding: 10px 0;
	text-align: center;
	background-color: white;

	& > div {
		margin: 0;
	}
`;

const Component = (props: Interface): ReactElement => {
	const dotsAmount = useLoadingDots();
	const intl = useIntl();

	return (
		<div {...props}>
			<div>{intl.formatMessage(msgs.connectionsProblem)}</div>
			<div>
				{intl.formatMessage(msgs.reconnecting)}
				{'.'.repeat(dotsAmount)}
			</div>
		</div>
	);
};

export const ConnectionCorrupted = styled(Component)(
	({ theme }: { theme: Theme }) => theme.chat.systemMessages.connectionCorruptedErrorMessage,
	styles
);
